
import BeSincereIcon from "../../assets/icons/Company/beSincere.svg";
import KeepIcon from "../../assets/icons/Company/Keep.svg";
import StrongerIcon from "../../assets/icons/Company/stronder.svg";
import TakeIcon from "../../assets/icons/Company/take.svg";


export const ABOUT_COMPANY = [
  {
    id: "0",
    img: BeSincereIcon,
    imgAlt: "BeSincereIcon",
    title: "Be Sincere",
  },

  {
    id: "1",
    img: KeepIcon,
    imgAlt: "KeepIcon",
    title: "Keep it simple",
  },

  {
    id: "2",
    img: StrongerIcon,
    imgAlt: "StrongerIcon",
    title: "Stronger together",
  },

  {
    id: "3",
    img: TakeIcon,
    imgAlt: "TakeIcon",
    title: "Take intelligent risks",
  },
];
